import { SelectOption } from "../common/components/form/Select";

export const PurposeCodeOptions: SelectOption[] = [
    {
        value: "ACCT",
        label: "ACCT - Account Management",
    },
    {
        value: "ADVA",
        label: "ADVA - Advance Payment",
    },
    {
        value: "AGRT",
        label: "AGRT - Agricultural Transfer",
    },
    {
        value: "AIRB",
        label: "AIRB - Air",
    },
    {
        value: "ALLW",
        label: "ALLW - Allowance",
    },
    {
        value: "ALMY",
        label: "ALMY - Alimony Payment",
    },
    {
        value: "ANNI",
        label: "ANNI - Annuity",
    },
    {
        value: "ANTS",
        label: "ANTS - Anesthesia Services",
    },
    {
        value: "AREN",
        label: "AREN - Account Receivable Entry",
    },
    {
        value: "BBSC",
        label: "BBSC - Baby Bonus Scheme",
    },
    {
        value: "BECH",
        label: "BECH - Child Benefit",
    },
    {
        value: "BENE",
        label: "BENE - Unemployment Disability Benefit",
    },
    {
        value: "BEXP",
        label: "BEXP - Business Expenses",
    },
    {
        value: "BOCE",
        label: "BOCE - Back Office Conversion Entry",
    },
    {
        value: "BONU",
        label: "BONU - Bonus Payment",
    },
    {
        value: "BUSB",
        label: "BUSB - Bus",
    },
    {
        value: "CASH",
        label: "CASH - Cash Management Transfer",
    },
    {
        value: "CBFF",
        label: "CBFF - Capital Building",
    },
    {
        value: "CBTV",
        label: "CBTV - Cable TV Bill",
    },
    {
        value: "CCRD",
        label: "CCRD - Credit Card Payment",
    },
    {
        value: "CDBL",
        label: "CDBL - Credit Card Bill",
    },
    {
        value: "CDCB",
        label: "CDCB - Credit Payment with Cashback",
    },
    {
        value: "CDCD",
        label: "CDCD - Cash Disbursement",
    },
    {
        value: "CDOC",
        label: "CDOC - Original Credit",
    },
    {
        value: "CDQC",
        label: "CDQC - Quasi Cash",
    },
    {
        value: "CFEE",
        label: "CFEE - Cancellation Fee",
    },
    {
        value: "CHAR",
        label: "CHAR - Charity Payment",
    },
    {
        value: "CLPR",
        label: "CLPR - Car Loan Principal Repayment",
    },
    {
        value: "CMDT",
        label: "CMDT - Commodity Transfer",
    },
    {
        value: "COLL",
        label: "COLL - Collection Payment",
    },
    {
        value: "COMC",
        label: "COMC - Commercial Payment",
    },
    {
        value: "COMM",
        label: "COMM - Commission",
    },
    {
        value: "COMT",
        label: "COMT - Consumer Third Party Consolidate Payment",
    },
    {
        value: "COST",
        label: "COST - Costs",
    },
    {
        value: "CPKC",
        label: "CPKC - Carpark Charges",
    },
    {
        value: "CPYC",
        label: "CPYC - Copyright",
    },
    {
        value: "CSDB",
        label: "CSDB - Cash Disbursement",
    },
    {
        value: "CSLP",
        label: "CSLP - Company Social Loan Payment To Bank",
    },
    {
        value: "CVCP",
        label: "CVCP - Convalescent Care facility",
    },
    {
        value: "DBTC",
        label: "DBTC - Debit Collection Payment",
    },
    {
        value: "DCRD",
        label: "DCRD - Debit Card Payment",
    },
    {
        value: "DEPT",
        label: "DEPT - Deposit",
    },
    {
        value: "DERI",
        label: "DERI - Derivatives",
    },
    {
        value: "DIVD",
        label: "DIVD - Dividend",
    },
    {
        value: "DMEQ",
        label: "DMEQ - Durable Medical Equipment",
    },
    {
        value: "DNTS",
        label: "DNTS - Dental Services",
    },
    {
        value: "EDUC",
        label: "EDUC - Education",
    },
    {
        value: "ELEC",
        label: "ELEC - Electricity Bill",
    },
    {
        value: "ENRG",
        label: "ENRG - Energies",
    },
    {
        value: "ESTX",
        label: "ESTX - Estate Tax",
    },
    {
        value: "FCPM",
        label: "FCPM - Payment of Fees & Charges",
    },
    {
        value: "FERB",
        label: "FERB - Ferry",
    },
    {
        value: "FREX",
        label: "FREX - Foreign Exchange",
    },
    {
        value: "FWLV",
        label: "FWLV - Foreign Worker Levy",
    },
    {
        value: "GASB",
        label: "GASB - Gas Bill",
    },
    {
        value: "GDDS",
        label: "GDDS - Purchase Sale Of Goods",
    },
    {
        value: "GDSV",
        label: "GDSV - Purchase Sale Of Goods And Services",
    },
    {
        value: "GOVI",
        label: "GOVI - Government Insurance",
    },
    {
        value: "GOVT",
        label: "GOVT - Government Payment",
    },
    {
        value: "GSCB",
        label: "GSCB - Purchase Sale Of Goods And Service With Cash Back",
    },
    {
        value: "GSTX",
        label: "GSTX - Goods & Services Tax",
    },
    {
        value: "HEDG",
        label: "HEDG - Hedging",
    },
    {
        value: "HLRP",
        label: "HLRP - Housing Loan Repayment",
    },
    {
        value: "HLTC",
        label: "HLTC - Home Health Care",
    },
    {
        value: "HLTI",
        label: "HLTI - Health Insurance",
    },
    {
        value: "HSPC",
        label: "HSPC - Hospital Care",
    },
    {
        value: "HSTX",
        label: "HSTX - Housing Tax",
    },
    {
        value: "ICCP",
        label: "ICCP - Irrevocable Credit Card Payment",
    },
    {
        value: "ICRF",
        label: "ICRF - Intermediate Care Facility",
    },
    {
        value: "IDCP",
        label: "IDCP - Irrevocable Debit Card Payment",
    },
    {
        value: "IHRP",
        label: "IHRP - Instalment Hire Purchase Agreement",
    },
    {
        value: "INPC",
        label: "INPC - Insurance Premium Car",
    },
    {
        value: "INSU",
        label: "INSU - Insurance Premium",
    },
    {
        value: "INTC",
        label: "INTC - Intra Company Payment",
    },
    {
        value: "INTE",
        label: "INTE - Interest",
    },
    {
        value: "INVS",
        label: "INVS - Investment & Securities",
    },
    {
        value: "IVPT",
        label: "IVPT - Invoice Payment",
    },
    {
        value: "LBRI",
        label: "LBRI - Labour Insurance",
    },
    {
        value: "LICF",
        label: "LICF - License Fee",
    },
    {
        value: "LIFI",
        label: "LIFI - Life Insurance",
    },
    {
        value: "LIMA",
        label: "LIMA - Liquidity Management",
    },
    {
        value: "LOAN",
        label: "LOAN - Loan",
    },
    {
        value: "LOAR",
        label: "LOAR - Loan Repayment",
    },
    {
        value: "LTCF",
        label: "LTCF - Long Term Care Facility",
    },
    {
        value: "MDCS",
        label: "MDCS - Medical Services",
    },
    {
        value: "MSVC",
        label: "MSVC - Multiple Service Type",
    },
    {
        value: "NETT",
        label: "NETT - Netting",
    },
    {
        value: "NITX",
        label: "NITX - Net Income Tax",
    },
    {
        value: "NOWS",
        label: "NOWS - Not Otherwise Specified",
    },
    {
        value: "NWCH",
        label: "NWCH - Network Charge",
    },
    {
        value: "NWCM",
        label: "NWCM - Network Communication",
    },
    {
        value: "OFEE",
        label: "OFEE - Opening Fee",
    },
    {
        value: "OTHR",
        label: "OTHR - Other",
    },
    {
        value: "OTLC",
        label: "OTLC - Other Telecom Related Bill",
    },
    {
        value: "PADD",
        label: "PADD - Preauthorised Debit",
    },
    {
        value: "PAYR",
        label: "PAYR - Payroll",
    },
    {
        value: "PENS",
        label: "PENS - Pension Payment",
    },
    {
        value: "PHON",
        label: "PHON - Telephone Bill",
    },
    {
        value: "POPE",
        label: "POPE - Point Of Purchase Entry",
    },
    {
        value: "PPTI",
        label: "PPTI - Property Insurance",
    },
    {
        value: "PRCP",
        label: "PRCP - Price Payment",
    },
    {
        value: "PRME",
        label: "PRME - Precious Metal",
    },
    {
        value: "PTSP",
        label: "PTSP - Payment Terms",
    },
    {
        value: "PTXP",
        label: "PTXP - Property Tax",
    },
    {
        value: "PCKE",
        label: "PCKE - Re-presented Check Entry",
    },
    {
        value: "RCPT",
        label: "RCPT - Receipt Payment",
    },
    {
        value: "RDTX",
        label: "RDTX - Road Tax",
    },
    {
        value: "REBT",
        label: "REBT - Rebate",
    },
    {
        value: "REFU",
        label: "REFU - Refund",
    },
    {
        value: "RENT",
        label: "RENT - Rent",
    },
    {
        value: "RINP",
        label: "RINP - Recurring Installment Payment",
    },
    {
        value: "RLWY",
        label: "RLWY - Railway",
    },
    {
        value: "ROYA",
        label: "ROYA - Royalties",
    },
    {
        value: "SALA",
        label: "SALA - Salary Payment",
    },
    {
        value: "SAVG",
        label: "SAVG - Savings",
    },
    {
        value: "SCVE",
        label: "SCVE - Purchase Sale of Services",
    },
    {
        value: "SECU",
        label: "SECU - Securities",
    },
    {
        value: "SSBE",
        label: "SSBE - Social Security Benefits",
    },
    {
        value: "STDY",
        label: "STDY - Study",
    },
    {
        value: "SUBS",
        label: "SUBS - Subscription",
    },
    {
        value: "SUPP",
        label: "SUPP - Supplier Payment",
    },
    {
        value: "TAXS",
        label: "TAXS - Tax Payment",
    },
    {
        value: "TBIL",
        label: "TBIL - Telco Bill",
    },
    {
        value: "TCSC",
        label: "TCSC - Town Council Service Charges",
    },
    {
        value: "TELI",
        label: "TELI - Telephone-Initiated Transaction",
    },
    {
        value: "TRAD",
        label: "TRAD - Trade Services",
    },
    {
        value: "TREA",
        label: "TREA - Treasury Payment",
    },
    {
        value: "TRFD",
        label: "TRFD - Trust Fund",
    },
    {
        value: "TRPT",
        label: "TRPT - Transport",
    },
    {
        value: "UBIL",
        label: "UBIL - Utilities",
    },
    {
        value: "VATX",
        label: "VATX - Value Added Tax Payment",
    },
    {
        value: "VIEW",
        label: "VIEW - Vision Care",
    },
    {
        value: "WEBI",
        label: "WEBI - Internet-Initiated Transaction",
    },
    {
        value: "WHLD",
        label: "WHLD - With Holding",
    },
    {
        value: "WTER",
        label: "WTER - Water Bill",
    },
];

export const CNYPurposeCodeOptions: SelectOption[] = [
    {
        value: "/BUSINESS/CAPITAL TRF",
        label: "Capital Transfer",
    },
    {
        value: "/BUSINESS/CHARITY DONATION",
        label: "Charity Donation",
    },
    {
        value: "/BUSINESS/CURRENT ACC TXN",
        label: "Current Account Transaction",
    },
    {
        value: "/BUSINESS/GOODS TRADE",
        label: "Goods Trade",
    },
    {
        value: "/BUSINESS/SERVICE TRADE",
        label: "Service Trade",
    },
];